import { useContext } from 'react';

import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { UserPermission } from 'data/__generated__';
import { UserContext } from 'contexts';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { UserList } from './components';
import { Link } from 'react-router-dom';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

export const Users = () => {
    const currentUser = useContext(UserContext);
    const isTotech = currentUser?.permissions?.some((p) => p.totemId == null && p.userGroup === UserPermission.Totech);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.users} />
                </HeaderTitle>
                <ButtonsContainer>
                    <Link to="/user/create-toteam">
                        <TotemPrimaryButton disabled={!isTotech}>Ajouter un utilisateur</TotemPrimaryButton>
                    </Link>
                </ButtonsContainer>
            </Header>
            <Content>
                <UserList />
            </Content>
        </Container>
    );
};

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
`;
